var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 692,
    viewBox: "0 0 600 692",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 172.741L0.207102 172.948H0L189.092 326.564L0 395.993L0.828409 519.052L227.822 432.786L194.063 630.887L300.104 692L338.833 452.118L496.445 578.919L600 519.052L411.115 365.436L600 293.305V172.948L372.385 259.214L406.766 61.322L300.104 0L261.374 239.675L107.491 110.587L0.207102 172.741H0Z",
    fill: "#FF6200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.e870c6717878bcd3ab17ae5c24120f77.svg";
export { ForwardRef as ReactComponent };